import UnknownCommonLinkTextNodeView from '@/component/message/text/component/common-link/component/unknown/index.vue';
import ChannelLinkCommonTextLinkNode from '@/component/message/text/component/common-link/component/channel-link/index.vue';
import WebLinkCommonLinkTextNodeView from '@/component/message/text/component/common-link/component/web-link/index.vue';
import BotConfigLinkCommonLinkTextNodeView from '@/component/message/text/component/common-link/component/bot-config-link/index.vue';
import AppLinkCommonLinkTextNodeView from '@/component/message/text/component/common-link/component/app-link/index.vue';
import BotWebLinkCommonLinkTextNodeView from '@/component/message/text/component/common-link/component/bot-web-link/index.vue';
import BotConfigEnhanceCommonLinkTextNodeView from '@/component/message/text/component/common-link/component/bot-config-enhance/index.vue';
import {
  setCommonLinkTextNodeConfigGenerateFunc,
  setInvalidCommonLinkTextNodeConfig,
  setUnknownCommonLinkTextNodeConfig,
} from '@/business/chat/generate-common-link-node-config';
import { CommonLinkTextNodeType } from '_c/typings/model/chat';

/**
 * 未知
 */
setUnknownCommonLinkTextNodeConfig({
  component: UnknownCommonLinkTextNodeView,
});

/**
 * 非法
 */
setInvalidCommonLinkTextNodeConfig({
  component: UnknownCommonLinkTextNodeView,
});

/**
 * 频道跳转
 */
setCommonLinkTextNodeConfigGenerateFunc(CommonLinkTextNodeType.channelLink, () => ({
  component: ChannelLinkCommonTextLinkNode,
}));

/**
 * app链接
 */
setCommonLinkTextNodeConfigGenerateFunc(CommonLinkTextNodeType.appLink, () => ({
  component: AppLinkCommonLinkTextNodeView,
}));

/**
 * web链接
 */
setCommonLinkTextNodeConfigGenerateFunc(CommonLinkTextNodeType.webLink, () => ({
  component: WebLinkCommonLinkTextNodeView,
}));

/**
 * bot配置
 */
setCommonLinkTextNodeConfigGenerateFunc(CommonLinkTextNodeType.botConfigLink, () => ({
  component: BotConfigLinkCommonLinkTextNodeView,
}));

/**
 * bot-web链接
 */
setCommonLinkTextNodeConfigGenerateFunc(CommonLinkTextNodeType.botWebLink, () => ({
  component: BotWebLinkCommonLinkTextNodeView,
}));

/**
 * bot配置增强
 */
setCommonLinkTextNodeConfigGenerateFunc(CommonLinkTextNodeType.botConfigWithParamLink, () => ({
  component: BotConfigEnhanceCommonLinkTextNodeView,
}));
